import ItinearyTextField from '@/src/components/common/itinerary/itinearyTextField'
import { Alert, Box, Button, CircularProgress, InputLabel, Stack, Typography } from '@mui/material'

const ForgotPasswordForm = ({ form, status, handlers, t }: any) => (
    <Stack
        spacing={2}
    >
        {status.error && (
            <Alert severity="error" >
                {status.error}
            </Alert>
        )}
        {status.success && (
            <Alert severity="success" >
                {status.success}
            </Alert>
        )}
        <Stack spacing={0}>
            <Typography variant="h6" sx={
                {
                    fontWeight: 700,
                    color: 'text.primary',

                }}>
                {t('forgotPasswordTitle')}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: 14, }}>{t('forgotPasswordDesc')}</Typography>
        </Stack>
        <Stack spacing={3}>
            <Box sx={{ width: '100%' }}>
                <InputLabel
                    shrink
                    htmlFor={`email`}
                    sx={{ fontWeight: 600, fontSize: 16, color: '#374151' }}
                >
                    {t('email')}
                </InputLabel>
                <ItinearyTextField
                    placeholder={t('forgotPasswordPlaceholder')}
                    type="email"
                    value={form.email}
                    onChange={handlers.handlers.changeEmailHandler}
                    error={!form.isEmailValid}
                    helperText={!form.isEmailValid ? t('invalidEmail') : ''}
                    sx={{
                        '& .MuiInputBase-input': { py: 0.5, px: 1.5, fontSize: 13, height: 26, borderRadius: 1 },
                        borderRadius: 1
                    }}
                />
            </Box>


            <Box display={"flex"} justifyContent={"space-between"} gap={2}>

                <Button
                    sx={{ flex: 1 }}
                    variant="outlined"

                    onClick={handlers.onBackToSignIn}
                >
                    {t('backToSignIn')}
                </Button>
                <Button
                    sx={{ flex: 1 }}
                    variant="contained"
                    onClick={handlers.onForgotPassword}
                    disabled={status.loading}
                >
                    {status.loading ? <CircularProgress size={24} color="inherit" /> : t('send')}
                </Button>

            </Box>
        </Stack>

    </Stack>
)

export default ForgotPasswordForm
